export const pathsWithTours = ['/dashboard/parts', '/dashboard/parts/request'];
